import { WritableSignal } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatSortable } from "@angular/material/sort";
import { BreadcrumbParms } from "@app/shared/components/breadcrumbs/breadcrumbs.model";
import { MenuOption } from "@app/shared/models/menu.model";

export class TabData {
  constructor(
    public menuOption: MenuOption,
    public data: any,
    public viewStates: ViewStates
  ) {}
}

/**
 * Standardized values used by tabLoader in loader-spinner
 */
export const TabLoaderStrokeWidth: number = 5;
export const TabLoaderDiameter: number = 70;

export class ViewState {
  constructor(
    public component: any,
    public pageIndex: number,
    public pageSize: number,
    public sortable: MatSortable,
    public searchItems: any[],
    public filter: string,
    public search: object,
    public data?: any,
    public uniqueId?: any
  ) {}
}

/**
 * Maintain list of view states for components in a tab.
 *
 * NOTE: This process will only work if the process is linear.
 *       If we move back more than 1 screen, this will not work and will need to be updated.
 */
export class ViewStates {
  private _viewStates: ViewState[] = [];

  constructor() {}

  /**
   * Add new view state to array
   * @param data
   */
  add(data: ViewState) {
    this._viewStates.push(data);
    return data;
  }

  /**
   * Remove latest view state
   */
  delete() {
    this._viewStates.splice(this.currentIndex, 1);
  }

  get viewStates() {
    return this._viewStates;
  }

  /**
   * Get current view state for active component
   */
  get currentViewState() {
    return this._viewStates[this.currentIndex];
  }

  get currentIndex(): number {
    return this._viewStates.length - 1;
  }
}

export class Tab {
  constructor(
    public id: string,
    public heading: string,
    public component: any,
    public favoritable: boolean,
    public hidden: WritableSignal<boolean>,
    public componentType: string,
    public data: TabData,
    public form: FormGroup,
    public icon?: string,
    public additionalHeading?: string,
    public additionalData?: any,
    public breadcrumb?: BreadcrumbParms,
    public useCautionModal?: boolean,
    public externalWindowRef?: WindowProxy,
    public isNavigationDisabled?: WritableSignal<boolean>,
    public previousTab?: Tab
  ) {}
}
